export default __webpack_public_path__ + "static/media/foto_carnet.71ed363d.png";